import { render } from "./RegistrationFormStep2.vue?vue&type=template&id=9b31d688"
import script from "./RegistrationFormStep2.vue?vue&type=script&lang=js"
export * from "./RegistrationFormStep2.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/craft-fos-scoutsmap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__